import React from 'react';
import useUserContext from 'Context/UserContext';
import fr from 'facet-rest';
import { Redirect } from 'react-router-dom';
import { CollectionStateProvider } from 'Context/CollectionStateContext';
import Container from './Container';

const UserAuthSetup = () => {
  const { userResource } = useUserContext();

  if (!userResource) {
    return null;
  }

  return userResource.withRelationship(fr.relationships.userAuthenticationSetup.name,
    (rel) => {
      return (
        <CollectionStateProvider
          args={{
            link: rel.link('related'),
          }}
        >
          <Container />
        </CollectionStateProvider>
      );
    },
    () => <Redirect to={'/'} />);
};

export default UserAuthSetup;
